// Read the rendered basis, including HTML transforms outside the SVG. Some
// mobile SVG implementations report an incomplete getScreenCTM after zoom.
// Zero-opacity probes also work for rotated nails in five/ten-finger views.
export function nailScreenMatrix(svg){
 const probes=svg?.querySelectorAll(':scope > [data-coordinate-probes] > rect');
 if(probes?.length===3){
  const p=[...probes].map(node=>{const r=node.getBoundingClientRect();return{x:r.x+r.width/2,y:r.y+r.height/2};});
  const a=(p[1].x-p[0].x)/100,b=(p[1].y-p[0].y)/100,c=(p[2].x-p[0].x)/150,d=(p[2].y-p[0].y)/150;
  if(Math.abs(a*d-b*c)>1e-8)return new DOMMatrix([a,b,c,d,p[0].x,p[0].y]);
 }
 return svg?.getScreenCTM();
}
